import { Typography, resetButtonStyle } from "matsuri-ui"
import { css } from "@emotion/react"
import { theme } from "../theme"

// matsuri-uiのInputBaseに一見見せかけたボタン
// mobileなどである、inputに見えるがタップするとModalが起動するタイプのボタンを表現するためのやつ
export const FieldLikeButton = ({
    label,
    value,
    onClick
}: {
    label?: string
    value?: string
    onClick?: () => void
}) => {
    return (
        <div
            css={css`
                display: grid;
                width: 100%;
            `}
        >
            <Typography variant="caption">{label}</Typography>
            <button
                type="button"
                css={[
                    resetButtonStyle,
                    css`
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;

                        width: 100%;
                        height: 42px;
                        padding: 0 12px;
                        color: ${theme.palette.text.primary};
                        background-color: white;
                        border: 1px solid ${theme.palette.action.active};
                        border-radius: 4px;

                        &:active {
                            background-color: ${
                                theme.palette.action.readOnlyBackground
                            };
                        }
                    `
                ]}
                onClick={onClick}
            >
                <Typography>{value}</Typography>
            </button>
        </div>
    )
}
